<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section" v-on:click="goTo('/corporations')">Corporaciones</a>
  </div>
  <h1 class="ui header"><i class="tablet alternate icon"></i><div class="content">Corporaciones</div></h1>
  <div v-if="!corporations" class="ui active centered inline loader"></div>
  <div v-if="corporations" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <table class="ui very basic compact selectable collapsing  table">
          <thead>
            <tr>
              <th class="azpian">Lista de corporaciones</th>
              <th class="right aligned">
                <div class="ui category search">
                  <div class="ui icon input field">
                    <input class="prompt" type="text" v-model="search" placeholder="Buscar corporación" @change="filteredList">
                      <i class="search icon"></i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="corporation in corporations" :key="corporation.Corporation.id">
              <td>
                <h4 class="ui image header">
                  <img v-if="corporation.Corporation.url" class="ui tiny image" :src="corporation.Corporation.url">
                  <img v-if="!corporation.Corporation.url" class="ui tiny image" src="../../assets/name.png">
                  <div class="content">
                    <div class="header">{{corporation.Corporation.name}}</div>
                    <div class="sub header">{{corporation.Corporation.address}}, {{corporation.Corporation.cp}}, {{corporation.Corporation.city}}</div>
                  </div>
                </h4>
              </td>
              <td>
                <div class="ui button" v-on:click="goTo('/corporations/' + corporation.Corporation.id+'/users/')">Listado de usuarios</div>
                <div class="ui button green" v-on:click="goTo('/corporations/' + corporation.Corporation.id+'/parcels/')">Listado de paquetes</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'Corporations',
  data() {
    return {
      corporations: null,
      search: null,
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin' || role === 'hmyCorporate') {
      this.getImages()
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    async getImages() {
      await hapiickApi().get('/v1/images/companies?admin_id='+JSON.parse(localStorage.admin).id)
      .then(request => {
        this.images = JSON.parse(JSON.stringify(request.data.data))
        this.getCorporations()
      })
      .catch((error) => {
        console.log('error getting images')
        console.log(error)
      })
    },
    getCorporations() {
      hapiickApi().post('/v1/corporations', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(request => {
        let corpo = JSON.parse(JSON.stringify(request.data.data.corporation))
        let allCorpo = []
        for (let i = 0; i < corpo.length; i++) {
          let url = this.images.find((e) => {
            return (e.key === corpo[i].Corporation.external_name)
          })
          if (url !== undefined) {
            corpo[i].Corporation.url = url.url
          } else {
            corpo[i].Corporation.url = null
          }
          allCorpo.push(corpo[i])
        }
        this.corporations = allCorpo
      })
      .catch(() => console.log('error getting corporations'))
    },
    goTo(where) {
      this.$router.push(where)
    },
    filteredList() {
      let clientlist= []
      if(this.search.length==0){
        this.getCorporations()
      }
      for (var i = 0; i < this.corporations.length; i++) {
        if(this.corporations[i].Corporation.name.toLowerCase().includes(this.search.toLowerCase()))
          clientlist.push(this.corporations[i])
      }
      this.corporations=clientlist
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Corporations/Corporations.vue